import ColorsStyles from '@Styles/colors.scss';
import { CircularProgress as MuiCircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

const StyledCircularProgress = styled(MuiCircularProgress)(
    () => `
    color: ${ColorsStyles.ikeGradient9};
    justify-self: center;
    align-self: center;
    margin: 40px 0px;
`
);

const CircularLoading = (props) => {
    return <StyledCircularProgress {...props} />;
};

export default CircularLoading;
